import { omit } from 'lodash-es';

export default {
  data() {
    return {
      sortingOptions: [],
      activeSortingOptions: [],
    };
  },
  methods: {
    isSortingOptionActive(name) {
      return this.activeSortingOptions.findIndex((option) => option.name === name) >= 0;
    },
    getSortingOptionValue(name) {
      const activeOption = this.activeSortingOptions.find((option) => option.name === name);

      if (activeOption === undefined) return 0;

      return activeOption.value;
    },
    setSortingOptions(optionList = []) {
      this.sortingOptions = [...optionList];

      return this;
    },

    setInitialSortingValuesFromRoute(route) {
      const {
        query: { sort = '' },
      } = route;

      const options = sort.trim().length > 0 ? sort.trim().split(',') : [];

      this.activeSortingOptions = [
        ...options.reduce((acc, option) => {
          const isDesc = option.indexOf('-') === 0;

          const name = isDesc ? option.substr(1) : option;
          const value = isDesc ? -1 : 1;

          return [...acc, { name, value }];
        }, []),
      ];

      return this;
    },

    activeSortingOptionsToString() {
      return this.activeSortingOptions
        .slice()
        .map(({ name, value }) => (value < 0 ? `-${name}` : name))
        .join(',');
    },

    toggleActiveSortingOption(name) {
      const index = this.activeSortingOptions.findIndex((option) => option.name === name);

      if (index === -1) {
        const option = { name, value: 1 };
        this.activeSortingOptions.push(option);
        return this;
      }

      const existing = this.activeSortingOptions[index];

      if (existing.value > 0) {
        existing.value = -1;
        return this;
      }

      this.activeSortingOptions.splice(index, 1);
      return this;
    },

    refreshRouteSorting() {
      const sort = this.activeSortingOptionsToString();
      const { name, params, query } = this.$route;

      this.$router.push({
        name,
        params,
        query: {
          ...omit(query, ['sort']),
          ...(sort ? { sort } : {}),
        },
      });
    },
  },
};
